import { Injectable } from "@angular/core";
import { AngularFireList, AngularFireDatabase } from '@angular/fire/database';
import { BehaviorSubject} from 'rxjs';
import { ModalController, AlertController, LoadingController } from '@ionic/angular';
import { isUndefined } from 'util';
import { CotationService } from './cotation.service';
import { SharedService } from '../sheared/sharedService.service';
import { authenticationService } from '../Authentication/authentication.service';


@Injectable({
  providedIn: 'root'
})


export class CotationSanteService  {


 
  ListTarifgabuni = new BehaviorSubject<any[]>([]);
  ListTarifgabmon = new BehaviorSubject<any[]>([]);
  ListsurpprimeAgeSante: any[] = []
    assistance = [{ OptionA: 70000, OptionB: 83000 }]
  resultatSante:any[]=[]
  ListAccessoire:any[]=[];
  // {mois:"",rub:"",prime:0,acc:0,Taxe:0,Ttc:0}




  constructor(private db: AngularFireDatabase,
    private authentic: authenticationService,private loadingController:LoadingController,
    private _shaerd:SharedService) {


      this.getaccessoires()

  }
 private async getaccessoires() {
  // this.loading2 = await this.loadingController.create({
  //   message: 'Envoi en cours...',
  //   // duration: 2000,
  //   spinner: 'bubbles'
  // });
  // this.loading2.present()
  //+this.codeAssur
    this.db.list("Accessoires/1010", ref => ref.orderByValue()).snapshotChanges(['child_added']).subscribe(
      (actions) => {
        const ListAccessoire = [];
        actions.forEach((action) => {
          ListAccessoire.push({
            acc: action.payload.exportVal().acc,
            min: action.payload.exportVal().min,
            max: action.payload.exportVal().max
          });
        })
        this.ListAccessoire=ListAccessoire
        //return ListAssreurs
      }
    )
  }

  calculPrimeNetteAssistance(nbPers: number,opt:string,coef): number {
    if (opt=="opA") {
      return this.assistance[0].OptionA * nbPers*coef
    } else if(opt=="opB") {
      return this.assistance[0].OptionB * nbPers*coef
    }else{
      return 0
    }

  }

  calculeCoefpourPeriode(dateEffet:Date,codeAssur:string){
        let coef=[1,1]//[santé,assistance]
        let an= new Date().getFullYear()

        let debut0= new Date(`${an}-01-01`)
        let fin0=new Date(`${an}-06-30`)

        let debut1= new Date(`${an}-07-01`)       
        let fin1=new Date(`${an}-12-31`)
        //SANTE CAS 1
        if ( this._shaerd.diffDays(debut0,dateEffet)>=0 && this._shaerd.diffDays(fin0,dateEffet)<=0 ) {
         
          coef[0]=(this._shaerd.diffDays(dateEffet,fin1)*1+1) / (this._shaerd.DayOfyear(new Date()))
        }//SANTE CAS 2
        else if ( this._shaerd.diffDays(debut1,dateEffet)>=0 && this._shaerd.diffDays(fin1,dateEffet)<=0 ){
          coef[0]=0.5
        }
        
        let bornSup=this._shaerd.DayOfyear(new Date())/2
        //ASSISTANCE CAS 1
        if (this._shaerd.diffDays(dateEffet,fin1)<bornSup) {       
          coef[1]=0.5
        }//ASSISTANCE CAS 2
        else if (this._shaerd.diffDays(dateEffet,fin1)>=bornSup && this._shaerd.diffDays(dateEffet,fin1)<=bornSup*2 ){
          coef[1]=1
        }

    return coef
  }
   calculPrimeTTCsante(dateEffet:Date,valadulte: string, valenfant: string, zone: any[],optAss:string, typeZone: string,coefNette:number[]) {
    let ad = valadulte.split(';') as []
    let en = valenfant.split(';') as []
    this.resultatSante=[]
    let mtEnfant = 0
    let mtAdulte = 0
    let mtsurpp = 0
    let nbEnf = 0
    let nbAd = 0
    let typeTarif: BehaviorSubject<any[]>
    if (typeZone === "unique") {
      typeTarif = this.ListTarifgabuni
    } else {
      typeTarif = this.ListTarifgabmon
    }
    let select = zone.filter(e => e.isChec === true)
    typeTarif.subscribe(
      res => {  
        res.forEach(resl => {
          if (resl.formule == select[0].formule) {
            en.forEach((e: string) => {
              let value = e.split(',')[1]
              if (!isUndefined(value) && resl.enfant > 0) {
                nbEnf += parseInt(value)
                mtEnfant +=parseInt(value) * resl.enfant
              }

            })
            ad.forEach((e: string) => {
              let value = e.split(',')[1]
              let rub = e.split(',')[0]
              if (!isUndefined(value) && resl.adulte > 0) {
                mtAdulte += parseInt(value) * resl.adulte
                nbAd += parseInt(value);
                this.ListsurpprimeAgeSante.forEach((sup) => {
                  if (rub === sup.rubrique) {
                    mtsurpp = mtsurpp + (parseInt(value) * resl.adulte * sup.value) / 100
                  }
                })


              }
              // mtAdulte=mtAdulte+e[1]*resl.adulte
            })

          }
        })

        let mT=0
        let acc=[]
        let access=this.ListAccessoire
        let myacc=1500
        this.resultatSante=[]
                mT = (mtAdulte + mtEnfant + mtsurpp)*coefNette[0]*1
                mT=this.bonusSante(nbEnf+nbAd,mT,coefNette[0])
                acc = access.filter(a => a.min <= mT && a.max >= mT)

                if (acc.length == 1) {
                  this.resultatSante.push({
                    periode:"",
                    rub:"SANTE",
                    prime:Math.round(mT),
                    acc:acc[0].acc * 1+myacc ,
                    Taxe:Math.round((acc[0].acc * 1 + mT) * 0.08),
                    Ttc:Math.round((acc[0].acc * 1 + mT) * 1.08),
                    open:false,
                    dateEf:dateEffet

                  })

                }

                if (typeZone==="monde") {
                      mT = this.calculPrimeNetteAssistance(nbEnf+nbAd,optAss,coefNette[1])
                      mT=this.bonusSante(nbEnf+nbAd,mT,coefNette[1])
                      acc = access.filter(a => a.min <= mT && a.max >= mT)
                      if (acc.length == 1) {
                            //this.resultatSante[0].valuePrimeAssist=Math.round((acc[0].acc * 1 + mT) * 1.08)
                            this.resultatSante.push({
                              periode:"",
                              rub:"ASSISTANCE",
                              prime:Math.round(mT),
                              acc:acc[0].acc * 1+myacc,
                              Taxe:Math.round((acc[0].acc * 1 + mT) * 0.08),
                              Ttc:Math.round((acc[0].acc * 1 + mT) * 1.08),
                              open:false,
                              dateEf:dateEffet
                            })

                      }
                }

               
            
          
        
      }
    )

    return this.resultatSante
    
    //console.log(this.resultatSante)
 // return  this.presentValidationPage(this.resultatSante)

  }
  bonusSante(nbPers:number,Nette:number,coef:number):number{
    let PrimeNette
    if (nbPers>=50 && nbPers<100) {
      PrimeNette=Nette*(1-10/100)
      // if (coef==0.5) {
      // this.resultatSante[0].valueRemise='10%'

      // }else{
      //   this.resultatSante[1].valueRemise='10%'
      // }
    } else if(nbPers>=100 && nbPers<500){
      PrimeNette=Nette*(1-15/100)
      // if (coef==0.5) {
      //   this.resultatSante[0].valueRemise='15%'

      //   }else{
      //     this.resultatSante[1].valueRemise='15%'
      //   }

    }else if(nbPers>=500 && nbPers<700){
      PrimeNette=Nette*(1-25/100)
      // if (coef==0.5) {
      //   this.resultatSante[0].valueRemise='15%'

      //   }else{
      //     this.resultatSante[1].valueRemise='15%'
      //   }

    }else if(nbPers>=700){
      PrimeNette=Nette*(1-35/100)
      // if (coef==0.5) {
      //   this.resultatSante[0].valueRemise='15%'

      //   }else{
      //     this.resultatSante[1].valueRemise='15%'
      //   }

    }



    else {
      PrimeNette=Nette
    }
    return PrimeNette;
  }
  bonusAssitance(nbPers:number,Nette:number,coef:number):number{
    let PrimeNette
    if (nbPers>=50 && nbPers<100) {
      PrimeNette=Nette*(1-10/100)
      // if (coef==0.5) {
      // this.resultatSante[0].valueRemise='10%'

      // }else{
      //   this.resultatSante[1].valueRemise='10%'
      // }
    } else if(nbPers>=100 && nbPers<500){
      PrimeNette=Nette*(1-15/100)
      // if (coef==0.5) {
      //   this.resultatSante[0].valueRemise='15%'

      //   }else{
      //     this.resultatSante[1].valueRemise='15%'
      //   }

    }else if(nbPers>=500 && nbPers<700){
      PrimeNette=Nette*(1-25/100)
      // if (coef==0.5) {
      //   this.resultatSante[0].valueRemise='15%'

      //   }else{
      //     this.resultatSante[1].valueRemise='15%'
      //   }

    }else if(nbPers>=700){
      PrimeNette=Nette*(1-35/100)
      // if (coef==0.5) {
      //   this.resultatSante[0].valueRemise='15%'

      //   }else{
      //     this.resultatSante[1].valueRemise='15%'
      //   }

    }



    else {
      PrimeNette=Nette
    }
    return PrimeNette;
  }
  getTarifSantesgabuni() {
    this.db.list("TarifSantes/1000", ref => ref.orderByChild("territorialite")
      .equalTo("gabunique")).snapshotChanges(['child_added']).subscribe(
        (actions) => {
          const ListTarif = [];

          actions.forEach((action) => {
            ListTarif.push({
              territorialite: action.payload.exportVal().territorialite,
              formule: action.payload.exportVal().formule,
              adulte: action.payload.exportVal().adulte,
              enfant: action.payload.exportVal().enfant,
              // assureur:action.payload.exportVal().assureur

            });
          })
          this.ListTarifgabuni.next(ListTarif)
          //return ListAssreurs
        }
      )
  }
 async getTarifSantesgabmon() {
     
    this.db.list("TarifSantes/1000", ref => ref.orderByChild("territorialite")
      .equalTo("gabmonde")).snapshotChanges(['child_added']).subscribe(
        (actions) => {
          const ListTarif = [];

          actions.forEach((action) => {
            ListTarif.push({
              territorialite: action.payload.exportVal().territorialite,
              formule: action.payload.exportVal().formule,
              adulte: action.payload.exportVal().adulte,
              enfant: action.payload.exportVal().enfant,
              // assureur:action.payload.exportVal().assureur

            });
          })
          this.ListTarifgabmon.next(ListTarif)
          //return ListAssreurs
        }
      )
  }
  getsurpprimeAgeSantes() {
    this.db.list("SurpprimeAgeSantes", ref => ref.orderByValue()).snapshotChanges(['child_added']).subscribe(
      (actions) => {
        const ListSurpprimeSante = [];
        actions.forEach((action) => {
          ListSurpprimeSante.push({
            rubrique: action.payload.exportVal().rubrique,
            value: action.payload.exportVal().value,
          });
        })
        this.ListsurpprimeAgeSante = ListSurpprimeSante
        //this.loading2.dismiss()
        //return ListAssreurs
      }
    )
  }
    // SANTE
  async instNewSante(sante: any,codeAssur,$key:string) {
    sante.CodeAssur=codeAssur
    sante.Quittance=$key
    sante.type="Sante"
    await this.db.list(`Cotations/${this.authentic.profile.uid}/Sante`).push(sante)
   }

}



